import { useEffect, useState, useRef } from 'react';

function useHover({ propagationClass } = {}) {
  const [value, setValueHook] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const setValue = val => {
      if (value !== val) setValueHook(val);
    };

    const isInside = e => {
      if (!propagationClass) return true;

      if (e.target === ref.current) return true;

      // check if parent of target is current ref (if so, it's inside)
      const parent = e.target.closest(`.${propagationClass}`);
      return ref.current === parent;
    };

    const isOutside = e => {
      if (!propagationClass) return true;
      // check if  propagation parent of target is current ref (if so, it's inside)
      const parent = e.relatedTarget.closest(`.${propagationClass}`);
      if (ref.current === parent) return false;

      // current ref contains the closet propagation parent so is above/outside
      if (ref.current.contains(parent)) return true;

      // relatedTarget isn't inside currenet ref
      if (ref.current.contains(e.relatedTarget)) {
        return true;
      }

      // leaving current ref
      if (e.fromElement === ref.current) return true;

      if (ref.current.contains(e.fromElement)) return true;

      // event is for current ref
      if (e.target === ref.current) return true;

      // event related target is parent of current ref
      return e.relatedTarget.contains(ref.current);
    };

    const handlemouseEnter = e => {
      // need to propagate events for other events like drag and drop
      if (isInside(e)) setValue(true);
    };
    const handleMouseOut = e => {
      if (isOutside(e)) setValue(false);
    };

    const node = ref.current;
    if (node) {
      node.addEventListener('mouseover', handlemouseEnter);
      node.addEventListener('mouseout', handleMouseOut);
    }

    return () => {
      if (node) {
        node.removeEventListener('mouseover', handlemouseEnter);
        node.removeEventListener('mouseout', handleMouseOut);
      }
    };
  }, [propagationClass, value]);
  return [ref, value, setValueHook];
}

export default useHover;
